function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg060Israel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#F0F0F0"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052B4"
    },
    d: "M352,200.575h-64.001L256,145.15l-31.998,55.425H160L192.002,256L160,311.425h64.002L256,366.85   l31.999-55.425H352L319.998,256L352,200.575z M295.314,256l-19.656,34.048h-39.314L216.686,256l19.657-34.048h39.314L295.314,256z    M256,187.903l7.316,12.672h-14.63L256,187.903z M197.028,221.952h14.632l-7.316,12.672L197.028,221.952z M197.028,290.048   l7.317-12.672l7.316,12.672H197.028z M256,324.097l-7.315-12.672h14.63L256,324.097z M314.972,290.048H300.34l7.317-12.672   L314.972,290.048z M300.34,221.952h14.632l-7.316,12.672L300.34,221.952z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 32,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    y: 416,
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 64
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg060Israel);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHBhdGggc3R5bGU9ImZpbGw6IzAwNTJCNDsiIGQ9Ik0zNTIsMjAwLjU3NWgtNjQuMDAxTDI1NiwxNDUuMTVsLTMxLjk5OCw1NS40MjVIMTYwTDE5Mi4wMDIsMjU2TDE2MCwzMTEuNDI1aDY0LjAwMkwyNTYsMzY2Ljg1ICAgbDMxLjk5OS01NS40MjVIMzUyTDMxOS45OTgsMjU2TDM1MiwyMDAuNTc1eiBNMjk1LjMxNCwyNTZsLTE5LjY1NiwzNC4wNDhoLTM5LjMxNEwyMTYuNjg2LDI1NmwxOS42NTctMzQuMDQ4aDM5LjMxNEwyOTUuMzE0LDI1NnogICAgTTI1NiwxODcuOTAzbDcuMzE2LDEyLjY3MmgtMTQuNjNMMjU2LDE4Ny45MDN6IE0xOTcuMDI4LDIyMS45NTJoMTQuNjMybC03LjMxNiwxMi42NzJMMTk3LjAyOCwyMjEuOTUyeiBNMTk3LjAyOCwyOTAuMDQ4ICAgbDcuMzE3LTEyLjY3Mmw3LjMxNiwxMi42NzJIMTk3LjAyOHogTTI1NiwzMjQuMDk3bC03LjMxNS0xMi42NzJoMTQuNjNMMjU2LDMyNC4wOTd6IE0zMTQuOTcyLDI5MC4wNDhIMzAwLjM0bDcuMzE3LTEyLjY3MiAgIEwzMTQuOTcyLDI5MC4wNDh6IE0zMDAuMzQsMjIxLjk1MmgxNC42MzJsLTcuMzE2LDEyLjY3MkwzMDAuMzQsMjIxLjk1MnoiLz4KCTxyZWN0IHk9IjMyIiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI2NCIvPgoJPHJlY3QgeT0iNDE2IiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI2NCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };